enum TaxiOfficerListingFilterType {
  FIRST_NAME = "FIRST_NAME",
  LAST_NAME = "LAST_NAME",
  USERNAME = "USERNAME",
  EMAIL = "EMAIL_ADDRESS",
  ACTIVITY_STATUS = "STATUS",
}

export default TaxiOfficerListingFilterType;
